module.exports = __webpack_public_path__ + "img/icon-sigin-in1.486e104c.svg";